export enum GuestType {
  Guest = "GUEST",
  Chapter = "CHAPTER",
  Member = "MEMBER",
}
